import React from 'react'
import PropType from 'prop-types'

import getLayoutConfig from 'utils/getLayoutConfig'

import styles from './styles.module.scss'
import CopyOnlyRichCta from './CopyOnlyRichCta'
import copyOnlyConfig from './copyOnlyConfig'

const CopyOnly = ({ href, theme, title, body, ctaText, nmls = false }) => {
  const { AboveCta } = getLayoutConfig(theme, copyOnlyConfig)

  return (
    <div className={styles.container}>
      <AboveCta />
      <CopyOnlyRichCta
        href={href}
        title={title}
        body={body}
        ctaText={ctaText}
        nmls={nmls}
        theme={theme}
      />
    </div>
  )
}

CopyOnly.propTypes = {
  href: PropType.string.isRequired,
  title: PropType.string.isRequired,
  theme: PropType.string.isRequired,
  body: PropType.string.isRequired,
  ctaText: PropType.string.isRequired,
  nmls: PropType.bool,
}

export default CopyOnly
